import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { consentApi } from './slices/consent';
import fileReducer from './slices/file';

export const store = configureStore({
  reducer: {
    [consentApi.reducerPath]: consentApi.reducer,
    file: fileReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(consentApi.middleware),
});

setupListeners(store.dispatch);